import type { AdbCredentialStore, AdbPrivateKey } from "@yume-chan/adb";

const STORAGE_KEY = "usb-device-workbench.adb.rsa-key.v1";

function toBase64(bytes: Uint8Array): string {
  let value = "";
  for (let offset = 0; offset < bytes.byteLength; offset += 0x8000) value += String.fromCharCode(...bytes.subarray(offset, offset + 0x8000));
  return btoa(value);
}

function fromBase64(value: string): Uint8Array {
  const binary = atob(value);
  return Uint8Array.from(binary, (character) => character.charCodeAt(0));
}

export class BrowserAdbCredentialStore implements AdbCredentialStore {
  private key?: AdbPrivateKey;

  iterateKeys(): Iterable<AdbPrivateKey> {
    if (!this.key) {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) this.key = { buffer: fromBase64(saved), name: "USB Device Workbench" };
    }
    return this.key ? [this.key] : [];
  }

  async generateKey(): Promise<AdbPrivateKey> {
    const keyPair = await crypto.subtle.generateKey(
      { name: "RSASSA-PKCS1-v1_5", modulusLength: 2048, publicExponent: new Uint8Array([1, 0, 1]), hash: "SHA-1" },
      true,
      ["sign", "verify"],
    );
    const buffer = new Uint8Array(await crypto.subtle.exportKey("pkcs8", keyPair.privateKey));
    this.key = { buffer, name: "USB Device Workbench" };
    localStorage.setItem(STORAGE_KEY, toBase64(buffer));
    return this.key;
  }
}
